// Mock data — Durga Facility Management Services (DFMS) Corporate Premium

export const brand = {
  name: 'Durga Facility Management Services',
  short: 'Durga',
  since: 2007,
  tagline: 'Integrated Facility Management Solutions Since 2007',
  phone: '0824-2438807',
  whatsapp: '919663919911',
  email: 'info@durgafacility.com',
  email2: 'enquiry@durgafacility.com',
  hrEmail: 'hr@durgafacility.com',
};

export const stats = [
  { num: '19+', label: 'Years of Experience' },
  { num: '1511+', label: 'Trained Workforce' },
  { num: '103+', label: 'Corporate Clients' },
  { num: '5', label: 'States of Operation' },
];

export const states = ['Karnataka', 'Goa', 'Maharashtra', 'Tamil Nadu', 'Telangana'];

export const heroSlides = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1554469384-e58fac16e23a?auto=format&fit=crop&w=2400&q=80',
    kicker: 'Since 2007 · India 500 Best MSME 2024',
    title: 'Integrated Facility Management',
    highlight: 'Solutions Since 2007.',
    subtitle:
      'A single accountable partner for housekeeping, security, technical maintenance, pest control, F&B, horticulture and drone facade cleaning — trusted by 103+ organisations across five states.',
  },
  {
    id: 2,
    image: '/assets/team-jetairways.webp',
    kicker: 'People + Process + Technology',
    title: 'Clean campuses. Safe premises.',
    highlight: 'Uninterrupted operations.',
    subtitle:
      'Trained, uniformed teams and modern equipment fleet deployed across hospitals, IT parks, universities, malls and manufacturing plants in Karnataka, Goa, Maharashtra, Tamil Nadu and Telangana.',
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1529939607658-044a84095c6f?auto=format&fit=crop&w=2400&q=80',
    kicker: 'Technology-first FM',
    title: 'Now offering',
    highlight: 'Drone Facade Cleaning.',
    subtitle:
      'India-ready drone cleaning for high-rise glass facades — safer than rope access, faster than BMU, and 60% less water than traditional methods.',
  },
];

export const services = [
  {
    slug: 'mechanized-housekeeping',
    title: 'Mechanized Housekeeping',
    short: 'Industrial-grade cleaning with ride-on scrubbers, HEPA vacuums and eco-safe chemicals for large commercial spaces.',
    icon: 'Sparkles',
    image: '/assets/mechanised-housekeeping.jpg',
    highlights: ['Ride-on auto scrubbers', 'HEPA-grade vacuums', 'Green cleaning chemicals', 'Restroom hygiene protocols'],
  },
  {
    slug: 'security-services',
    title: 'Security Services',
    short: 'Licensed armed & unarmed guards, CCTV surveillance and fire-safety personnel with 24×7 supervision.',
    icon: 'ShieldCheck',
    image: '/assets/security-formation.webp',
    highlights: ['Armed & unarmed guards', 'Fire & safety trained', 'CCTV monitoring', 'Access & visitor control'],
  },
  {
    slug: 'technical-maintenance',
    title: 'Technical Maintenance',
    short: 'Preventive & reactive maintenance for electrical, HVAC, DG, plumbing and BMS systems by certified engineers.',
    icon: 'Wrench',
    image: '/assets/technical-maintenance.webp',
    highlights: ['Electro-mechanical MEP', 'HVAC & DG maintenance', 'Plumbing & fire systems', 'BMS integration'],
  },
  {
    slug: 'pest-management',
    title: 'Pest Management',
    short: 'Integrated Pest Management with minimal chemical footprint — safe for hospitals, food-service and offices.',
    icon: 'Bug',
    image: '/assets/pest-management.webp',
    highlights: ['General pest control', 'Rodent management', 'Termite treatment', 'Fumigation & fogging'],
  },
  {
    slug: 'food-beverage',
    title: 'Food & Beverage',
    short: 'FSSAI-compliant kitchens delivering meals, snacks, pantry and cafeteria services with hygienic sourcing.',
    icon: 'UtensilsCrossed',
    image: '/assets/food-beverage.png',
    highlights: ['Corporate cafeterias', 'Industrial canteens', 'Institutional catering', 'Pantry & barista services'],
  },
  {
    slug: 'horticulture',
    title: 'Horticulture',
    short: 'Garden development, lawn care and landscape maintenance for corporate campuses and residential communities.',
    icon: 'Leaf',
    image: '/assets/horticulture.jpg',
    highlights: ['Landscape design', 'Lawn & tree care', 'Irrigation management', 'Seasonal plantation'],
  },
  {
    slug: 'manpower-deployment',
    title: 'Manpower Deployment',
    short: 'Background-verified, trained personnel across skill levels — deployed under statutory compliance and supervised SLAs.',
    icon: 'Users',
    image: '/assets/front-office.png',
    imgFit: 'contain',
    imgBg: '#f8fafc',
    highlights: ['Front office & reception', 'Skilled & semi-skilled labour', 'Payroll & compliance', 'Uniforms & PPE'],
  },
  {
    slug: 'facade-maintenance',
    title: 'Facade Maintenance',
    short: 'High-rise facade cleaning via rope access and BMU with world-class safety and quality management systems.',
    icon: 'Building2',
    image: 'https://images.pexels.com/photos/14388936/pexels-photo-14388936.jpeg?auto=compress&cs=tinysrgb&w=1400&q=80',
    highlights: ['Rope-access cleaning', 'BMU operations', 'Safety certification', 'Glass & cladding care'],
  },
  {
    slug: 'drone-facade-cleaning',
    title: 'Drone Facade Cleaning',
    isNew: true,
    short: 'India-ready drone cleaning for high-rise glass — safer than rope access, faster than BMU, 60% less water.',
    icon: 'Plane',
    image: '/assets/drone-facade-cleaning.jpg',
    video: '/assets/drone-cleaning.mp4',
    imgFit: 'contain',
    imgBg: '#0A2540',
    highlights: ['Autonomous & piloted drones', 'Ideal for high-rises', 'Water & chemical efficient', 'Zero worker-at-height risk'],
  },
];

export const industries = [
  { name: 'IT & Tech Parks', icon: 'Building2', image: '/assets/industry-it.png', imgPos: 'center 30%' },
  { name: 'Hospitals & Healthcare', icon: 'HeartPulse', image: '/assets/industry-healthcare.webp', imgPos: 'center 40%' },
  { name: 'Manufacturing', icon: 'Factory', image: '/assets/industry-manufacturing.webp', imgPos: 'center 40%' },
  { name: 'Aviation & Transportation', icon: 'Plane', image: '/assets/industry-aviation.webp', imgPos: 'center 40%' },
  { name: 'Retail & Malls', icon: 'ShoppingBag', image: '/assets/industry-retail.png', imgPos: '35% center' },
  { name: 'Universities & Schools', icon: 'GraduationCap', image: '/assets/industry-education.webp', imgPos: '65% center' },
  { name: 'Hospitality', icon: 'Utensils', image: '/assets/industry-hospitality.jpg', imgPos: 'center 30%' },
  { name: 'Government', icon: 'Landmark', image: 'https://images.unsplash.com/photo-1709967884183-7ffa9d168508?auto=format&fit=crop&w=1000&q=80' },
  { name: 'Residential', icon: 'Home', image: '/assets/industry-residential.webp', imgPos: 'center 25%' },
];

export const whyChooseUs = [
  { icon: 'Award', title: 'Award-Winning Track Record', desc: 'India 500 Best MSME Award 2024. Over 30 years of measurable outcomes for organisations across sectors.' },
  { icon: 'Users', title: 'Trained Manpower', desc: 'Background-verified, uniformed and continuously trained on equipment, safety and soft skills — a skilled workforce across every category of facility service.' },
  { icon: 'Cpu', title: 'Technology-First Operations', desc: 'From ride-on scrubbers to drone cleaning and BMS integration — modern equipment powering every SLA.' },
  { icon: 'Leaf', title: 'Sustainability by Design', desc: 'Green-building aligned processes, reduced water and chemical footprint and audited waste management.' },
  { icon: 'ShieldCheck', title: 'Compliance & Safety', desc: 'ISO-aligned, statutory-compliant payroll, PF/ESI, PPE and structured safety training.' },
  { icon: 'HeadphonesIcon', title: '24×7 Supervision', desc: 'Dedicated site managers, escalation matrix, monthly reviews and digital reporting.' },
];

export const approachSteps = [
  { step: '01', title: 'Discover', desc: 'Free on-site walkthrough, requirement mapping and benchmark audit.' },
  { step: '02', title: 'Design', desc: 'Custom scope, SLA and manpower plan aligned to your budget and KPIs.' },
  { step: '03', title: 'Deploy', desc: 'Trained, verified staff mobilised with equipment, uniforms and compliance.' },
  { step: '04', title: 'Deliver', desc: 'Supervised operations with monthly reviews and continuous improvement.' },
];

export const certifications = [
  { name: 'ISO 9001:2015', desc: 'Quality Management System' },
  { name: 'ISO 14001:2015', desc: 'Environmental Management' },
  { name: 'ISO 45001:2018', desc: 'Occupational Health & Safety' },
  { name: 'FSSAI Licensed', desc: 'Food safety compliance' },
  { name: 'MSME Registered', desc: 'India 500 Best MSME 2024' },
  { name: 'PSARA Licensed', desc: 'Private Security Agency' },
];

export const testimonials = [
  {
    id: 1,
    name: 'K.S.R.T.C',
    location: 'Mangaluru Division',
    role: 'Housekeeping · Since 2010',
    logo: 'https://durgafacility.com/wp-content/uploads/2022/12/client6-1.jpg',
    text: 'Durga is carrying housekeeping services for 8 bus stations of K.S.R.T.C. Mangaluru Division since June 2010 and their performance is very satisfying.',
  },
  {
    id: 2,
    name: 'Mangaluru Milk Dairy',
    location: 'Mangaluru',
    role: 'Canteen Services',
    logo: 'https://durgafacility.com/wp-content/uploads/2022/12/client4-2.jpg',
    text: 'As a canteen service contractor Durga has provided canteen services to our Mangaluru Dairy campus and the service rendered has been excellent.',
  },
  {
    id: 3,
    name: 'Manipal University',
    location: 'Manipal',
    role: 'Mechanized Housekeeping',
    logo: 'https://durgafacility.com/wp-content/uploads/2022/12/client5-1.jpg',
    text: 'Durga has executed mechanized housekeeping and cleaning contract in our university institutions. Their services during the contract period have been excellent and committed.',
  },
  {
    id: 4,
    name: 'Reliance Life Sciences',
    location: 'Bangalore',
    role: 'Housekeeping + Clinical Manpower',
    logo: 'https://durgafacility.com/wp-content/uploads/2022/12/client1-1.jpg',
    text: 'Engaged for mechanized housekeeping and clinical manpower deployment at our Bangalore facility. Very efficient in delivering services to the best of our satisfaction.',
  },
  {
    id: 5,
    name: 'Bharath Mall',
    location: 'Mangaluru',
    role: 'Housekeeping & Maintenance',
    logo: 'https://durgafacility.com/wp-content/uploads/2022/12/client2-2.jpg',
    text: 'Entrusted with mechanized housekeeping and maintenance of our building. We have found their services to be efficient and organized in operations and execution.',
  },
  {
    id: 6,
    name: 'Visvesaraya Technological University',
    location: 'Belgaum',
    role: 'Catering Services',
    logo: 'https://durgafacility.com/wp-content/uploads/2022/12/client3-3.jpg',
    text: 'Durga is serving the catering needs of the students and staff of VTU. Their services are satisfactory, hygienic and consistently good.',
  },
];

export const clientLogos = [
  '/assets/client-mresult.png',
  '/assets/client-hgs.jpg',
  '/assets/client-beml.webp',
  'https://durgafacility.com/wp-content/uploads/2023/01/shree-durgaparemeshwari-temple-kateel.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/11/1.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/11/vtu_logo.png',
  'https://durgafacility.com/wp-content/uploads/2022/11/logo-1.png',
  'https://durgafacility.com/wp-content/uploads/2022/11/logo3.png',
  'https://durgafacility.com/wp-content/uploads/2022/11/908659.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/11/n1.png',
  'https://durgafacility.com/wp-content/uploads/2022/11/n2.png',
  'https://durgafacility.com/wp-content/uploads/2022/11/n3.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/11/n4.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/11/n6.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/11/n5.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/12/L2.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/12/L1.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/12/L5.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/12/L4.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/12/L3.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/12/L7.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/12/L8.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/12/l9.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/12/envoy-logo.svg',
  'https://durgafacility.com/wp-content/uploads/2022/12/L10.jpg',
  'https://durgafacility.com/wp-content/uploads/2022/12/indiana-hospital-logo-2.webp',
  'https://durgafacility.com/wp-content/uploads/2022/12/syngene-logo.svg',
  'https://durgafacility.com/wp-content/uploads/2022/12/img-logo-cinepolis-1.png',
  'https://durgafacility.com/wp-content/uploads/2022/12/big-cinemas-logo.png',
  'https://durgafacility.com/wp-content/uploads/2022/12/bharat-logo.png',
  'https://durgafacility.com/wp-content/uploads/2022/12/gok-Logo.png',
  'https://durgafacility.com/wp-content/uploads/2023/01/excellent-pu-college.jpg',
  'https://durgafacility.com/wp-content/uploads/2023/01/vihangama-holiday-retreat.jpg',
];

export const faqs = [
  {
    q: 'Which regions do you operate in?',
    a: 'Durga actively operates across Karnataka, Goa, Maharashtra, Tamil Nadu and Telangana, with regional offices in Mangalore, Bengaluru and Mumbai. We can mobilise teams to new locations within 2–4 weeks.',
  },
  {
    q: 'How quickly can you deploy a team at our facility?',
    a: 'For standard housekeeping and security assignments, mobilisation takes 7–14 days from signed proposal. Complex integrated engagements are typically deployed in 3–5 weeks, including uniforms, training and compliance.',
  },
  {
    q: 'Are your workers background-verified and trained?',
    a: 'Yes. Every Durga professional undergoes police verification, medical fitness screening and role-specific training before deployment. We maintain full statutory compliance (PF, ESI, gratuity, insurance).',
  },
  {
    q: 'Do you offer drone facade cleaning in India?',
    a: 'Yes. Durga is among the few Indian IFM providers offering drone facade cleaning for high-rise glass buildings — safer, faster and up to 60% more water-efficient than traditional rope-access methods.',
  },
  {
    q: 'What certifications does Durga hold?',
    a: 'We are ISO 9001, 14001 and 45001 aligned, FSSAI licensed for food services, PSARA licensed for security, and were awarded the India 500 Best MSME Award in 2024.',
  },
  {
    q: 'Can I request a free facility audit?',
    a: 'Absolutely. Book a free on-site audit through our Contact form or WhatsApp. Our senior consultants will benchmark your current operations and share a proposal within 72 hours.',
  },
];

export const careerOpenings = [
  { title: 'Facility Manager', location: 'Bengaluru', type: 'Full-time', exp: '5-8 yrs', desc: 'Lead a portfolio of corporate campuses. Own SLAs, manpower planning, compliance and client relationships.' },
  { title: 'Site Supervisor — Housekeeping', location: 'Mangaluru', type: 'Full-time', exp: '2-4 yrs', desc: 'Supervise mechanized housekeeping teams; ensure quality, safety and daily reporting.' },
  { title: 'Business Development Executive', location: 'Mumbai', type: 'Full-time', exp: '3-5 yrs', desc: 'Drive large-account acquisition across IT parks, healthcare and manufacturing verticals.' },
  { title: 'Drone Pilot — Facade Cleaning', location: 'Bengaluru / Mumbai', type: 'Full-time', exp: '2-5 yrs', desc: 'Operate and maintain commercial drone systems for high-rise glass cleaning operations.' },
  { title: 'Pest Control Technician', location: 'Multiple cities', type: 'Full-time', exp: '1-3 yrs', desc: 'Execute Integrated Pest Management programs at client sites with modern tools and eco-safe protocols.' },
];

export const contactInfo = {
  registered: {
    title: 'Registered Office — Mangalore',
    address: '“Bondala Annex”, 1st Floor, Soorya Narayana Temple Road, Opp Mescom office (NH73), Maroli, Kulshekar, Mangalore, Karnataka — 575005.',
    phone: '0824-2438807',
    email: 'info@durgafacility.com',
    email2: 'enquiry@durgafacility.com',
    mapUrl: 'https://maps.app.goo.gl/CNPiun6sd7emJT119',
  },
  mumbai: {
    title: 'Mumbai Office',
    address: 'No.11, Plot No. 28A, Tandan Chawl, (Next to Hotel Vishwa Vihar), Opp. Cotton Green Rly. Station, SH Road, Kala Chowki, Mumbai — 400 033.',
    phone: '+91 8431510073',
  },
  bangalore: {
    title: 'Bangalore Office',
    address: 'No 14, Ground Floor, Vishwanatha Rao Road, Madhavanagar, Bengaluru — 560001.',
    phone: '+91 7795056184',
    email: 'bengaluru@durgafacility.com',
    mapUrl: 'https://maps.app.goo.gl/T5BPPhyPuPbA2i9U8',
  },
};
